<template>
  <div id="apex-charts-radial-bar">
    <header class="radial-bar-title">
      <h4 class="radial-bar-title-text">
        {{ title }}
      </h4>
    </header>

    <div v-if="isDataIn" class="radial-bar-body">
      <apexchart type="radialBar" height="150" width="150" :options="chartOptions" :series="sources" v-if="sources && sources.length > 0"></apexchart>
    </div>
    <div v-else class="align-center pt-20" style="width:100%;">
      <div class="card-text-title no-data" style="width:100%;">
        No Data In
      </div>
    </div>
  </div>
</template>
<script>
import _ from "lodash";
export default {
  props: {
    isDataIn: { type: Boolean, default: false },
    title: { type: String, default: "" },
    series: { type: Array, default: () => [] }
  },

  data() {
    return {
      sources: [],
      chartOptions: {
        chart: {
          height: 150,
          type: "radialBar"
        },
        plotOptions: {
          radialBar: {
            hollow: {
              size: "50%"
            },
            track: {
              background: "#666669"
            },
            dataLabels: {
              showOn: "always",
              name: {
                show: false
              },
              value: {
                offsetY: 5,
                color: "#fff",
                fontFamily: "Roboto-Bold",
                fontSize: "18px",
                show: true
              }
            }
          }
        },
        labels: ["Total"]
      }
    };
  },

  mounted() {
    this.sources = _.cloneDeep(this.series);
  },

  watch: {
    series: function(values) {
      this.sources = _.cloneDeep(values);
    }
  }
};
</script>
<style lang="scss" scoped>
#apex-charts-radial-bar {
  text-align: center;
  min-width: 125px;
  height: 100%;

  .radial-bar-title {
    margin-bottom: 4px;

    .radial-bar-title-text {
      width: 50px;
      font-size: 12px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      text-align: center;
      line-height: 1;
      margin: 0 auto;
    }
  }

  .radial-bar-body {
    padding: 0;
  }
}
</style>
